import React from 'react';
import { AppSection, type Language } from '../types';
import { translations } from '../shared/i18n';
import { RTL } from '../shared/i18n';
import BottomNav from './BottomNav';

interface LayoutProps {
  children: React.ReactNode;
  activeSection: AppSection;
  onSectionChange: (section: AppSection) => void;
  lang: Language;
  setLang: (lang: Language) => void;
}

const NEXT_LANG: Record<Language, Language> = { fr: 'ar', ar: 'en', en: 'fr' };
const NEXT_LABEL: Record<Language, string> = { fr: 'ع', ar: 'EN', en: 'FR' };

const Layout: React.FC<LayoutProps> = ({ children, activeSection, onSectionChange, lang, setLang }) => {
  const t = translations[lang];

  return (
    <div className={`flex flex-col min-h-screen pb-20 max-w-lg mx-auto bg-slate-50 ${RTL[lang] ? 'font-arabic' : ''}`}>
      <header className="sticky top-0 z-40 bg-[#C1272D] text-white px-4 py-3 shadow-sm flex justify-between items-center">
        <div className="flex items-center gap-2">
          {/* The app is served under /app, so asset URLs go through BASE_URL.
              A bare "/assets/..." would resolve against the marketing site. */}
          <img
            src={`${import.meta.env.BASE_URL}assets/icon-192.png`}
            alt=""
            className="w-8 h-8 object-contain bg-white rounded-lg p-0.5"
          />
          <h1 className="text-base font-extrabold tracking-tight">{t.appName}</h1>
        </div>
        <button
          onClick={() => setLang(NEXT_LANG[lang])}
          aria-label={t.language}
          className="bg-[#006233] px-4 h-9 min-w-[44px] rounded-full text-xs font-extrabold shadow-sm"
        >
          {NEXT_LABEL[lang]}
        </button>
      </header>

      <main className="flex-1 p-4">{children}</main>

      <footer className="text-center py-4 text-[11px] text-slate-400 leading-relaxed">
        <a
          href="https://quickdelivery.pro"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#C1272D] font-semibold hover:underline"
        >
          quickdelivery.pro
        </a>
        <br />
        <span>{t.byVendor} </span>
        <a
          href="https://www.nexure.org"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold hover:underline"
        >
          Nexure LLC
        </a>
        <span className="mx-1">·</span>
        <a href="https://www.nexure.org" target="_blank" rel="noopener noreferrer" className="hover:underline">
          www.nexure.org
        </a>
      </footer>

      <BottomNav activeSection={activeSection} onSectionChange={onSectionChange} lang={lang} />
    </div>
  );
};

export default Layout;
